/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useEffect, useState } from 'react';
import { Card, Icon } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import SharedTabsWidget from '../../shared/SharedTabs/SharedTabs';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  DataContextProvider,
  IDataConnectorConfigRaw
} from '@forge/data-connector';
import { ApiContext } from '../../../context/ApiContext';
import TotalEmissionsDetailsComponent from './TotalEmissionsTab/TotalEmissionsDetailsComponent';
import CarbonScopeOneDetailsComponent from './CarbonScopeOneTab/CarbonScopeOneDetailsComponent';
import CarbonScopeTwoDetailsTabComponent from './CarbonScopeTwoTab/CarbonScopeTwoDetailsComponent';
import './CarbonDetailViewDetailsTheme.scss';
import { FilterScope1Provider } from '../../../context/FilterScope1Context/FilterScope1Context';
import PortfolioCarbonAvoidanceTabComponet from '../PortfolioCarbonSiteViewDetailsComponent/PortfolioCarbonAvoidance/PortfolioCarbonAvoidanceTabComponet';
import { SmartPowerSubscriptionType } from '../../shared/Enums';

const CarbonSiteViewDetailsComponentContent = (
  props: IEnergyManagementProps
) => {
  const { bearerToken, requestContext } = props;
  const d = descriptors.DetailedView;
  const [t] = useTranslation();
  const apiContext = useContext(ApiContext);
  const { onBacktoDashboardClick, isFromSmartPower } = apiContext!;
  const onBackarrowClick = () => {
    if (onBacktoDashboardClick) {
      onBacktoDashboardClick(isFromSmartPower);
    }
  };
  const {
    cemsEnableCarbonSourceSelect,
    dataSourceType,
    setDataSourceType,
    cemsIntervalEnergySourceOption
  } = apiContext;

  const displayTabs = {
    displayTabs: [
      {
        className: 'emaas-carbondetail-view-details-total-emissions',
        title: t(d.TOTALEMISSIONS),
        component: TotalEmissionsDetailsComponent
      },
      {
        className: 'emaas-utility-view-details-scope-one',
        title: t(d.SCOPE1),
        component: CarbonScopeOneDetailsComponent
      },
      {
        className: 'emaas-utility-view-details-scope-two',
        title: t(d.SCOPE2),
        component: CarbonScopeTwoDetailsTabComponent
      }
    ],
    bearerToken: bearerToken,
    requestContext,
    ActiveIndex: apiContext?.ActiveIndex,
    enableConsumptionSourceSelect: cemsEnableCarbonSourceSelect,
    isCarbonSourceConsumptionSelect: true,
    dataSourceType,
    setDataSourceType,
    hideDataSourceSelectForIndices: [] as number[],
    cemsIntervalEnergySourceOption
  };

  if (
    requestContext.context.smpSubscriptionType ===
    SmartPowerSubscriptionType.PREMIUM_SUBSCRIPTION
  ) {
    displayTabs.displayTabs.push({
      className: 'emaas-carbondetail-view-details-total-emissions',
      title: t(d.CARBONAVOIDANCE),
      component: PortfolioCarbonAvoidanceTabComponet
    });
    displayTabs.hideDataSourceSelectForIndices.push(3);
  }

  return (
    <FilterScope1Provider>
      <div className="emaas-carbonview-container-kpi-card-common">
        <Card>
          <Card.Header className="emaas-carbonviewdetail-viewDetails-kpi-header-container">
            <div className="emaas-carbonviewdetail-viewDetails-kpi-card-title">
              <span className="carbonviewdetail-backButton">
                <Icon
                  root="common"
                  name="arrow-left"
                  size="medium"
                  onClick={() => onBackarrowClick()}
                />
              </span>
              {t(d.CARBONTITLE)}
            </div>
          </Card.Header>
          <Card.Content className="emaas-carbonviewdetail-viewDetails-kpi-content-container">
            <DataContextProvider
              config={props.connectorConfig as IDataConnectorConfigRaw}
            >
              <SharedTabsWidget {...displayTabs} />
            </DataContextProvider>
          </Card.Content>
        </Card>
      </div>
    </FilterScope1Provider>
  );
};

export default CarbonSiteViewDetailsComponentContent;
